<template>
  <div class="schedule">
    <el-divider content-position="left">客户来源统计</el-divider>

    <el-collapse v-model="activeOpen">
      <el-collapse-item title="高级筛选">
        <div style="padding: 10px">
          <el-row :span="24">
            <el-col :span="3">会员注册时间</el-col>
            <el-col :span="6">
              <el-date-picker size="mini" v-model="searchArr.vip_reg" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
            <el-col :span="3" :offset="2">订单创建时间</el-col>
            <el-col :span="6">
              <el-date-picker size="mini" v-model="searchArr.order_date" type="daterange" align="right" unlink-panels
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="ysyTypeInPickerOptions" value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-col>
          </el-row>
          <el-row class="tr">
            <el-button type="primary" size="mini" @click="handleASearSub">查询</el-button>
            <el-button type="danger" size="mini" @click="handleASearClear">清除</el-button>
          </el-row>
        </div>
      </el-collapse-item>
    </el-collapse>

    <el-table :data="userSource" border size="medium" :show-summary="true" style="width: 100%" v-cloak
      :header-cell-style="{
      background: '#ecf4ff',
      color: '#333',
      fontWeight: '900',
      fontSize: '0.28rem',
    }">
      <el-table-column label="小程序名称" width="60" prop="name">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleGetTypeUser(scope.row.type)" :underline="false">{{ scope.row.name
            }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="会员注册量" width="100" prop="user_lists">
        <template slot-scope="scope">
          <div>
            {{ scope.row.user_lists }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="订单数量" width="100" prop="order_lists">
        <template slot-scope="scope">
          <div>
            {{ scope.row.order_lists }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下单未付款" width="100" prop="unpay_lists">
        <template slot-scope="scope">
          <div>
            {{ scope.row.unpay_lists }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 类型弹窗 -->
    <el-drawer :title="titleName" :visible.sync="typeUserDrawer" direction="rtl" size="50%"
      :before-close="handleTypeClose">
      <el-row :span="24" style="margin-bottom: 0.4rem; margin-left: 0.2rem">
        <el-col :span="8">
          <el-input v-model="typeForm.phone" placeholder="输入手机号搜索" size="mini" @change="handleTypeSerch"
            clearable></el-input>
        </el-col>
      </el-row>
      <el-table v-if="!loading" :data="userLists" border size="medium" style="width: 98%; margin: 0 auto" v-cloak
        :header-cell-style="{
      background: '#ecf4ff',
      color: '#333',
      fontWeight: '900',
      fontSize: '0.28rem',
    }">
        <el-table-column label="昵称" width="120">
          <template slot-scope="scope">
            <span class="count-style">{{ scope.row.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" width="120">
          <template slot-scope="scope">
            <!-- <el-link class="ellipsis-link" :underline="false" type="primary" @click="handleOrderInfoOpen(scope.row.phone)">{{ scope.row.phone }}</el-link> -->
            <!-- <span>{{ scope.row.phone }}</span> -->
            <phone-com v-if="scope.row.phone" :comPhone="scope.row.phone" :vagaryPhone="scope.row.vagary_phone"
              style="display: inline-block" />
          </template>
        </el-table-column>
        <el-table-column label="性别" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.gender || scope.row.sex }}</span>
          </template>
        </el-table-column>
        <el-table-column label="注册时间" width="120">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.created_at || scope.row.regtime }}</span> -->
            <date-formatter :date-value="scope.row.created_at ? scope.row.created_at : scope.row.regtime"></date-formatter>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background class="tr mt-10" layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="[15, 30, 50]"
        :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </el-drawer>

    <el-drawer title="已支付订单详情" :visible.sync="handlePayerContentDrawer" direction="rtl" :before-close="handleClose"
      size="50%" class="PayerContent">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-table :data="userOrderWithData" size="small" border style="width: 100%; margin-top: 0.2rem" v-cloak>
          <el-table-column label="订单号" prop="order_num" width="255">
            <template slot-scope="scope">
              <el-link style="cursor: pointer;color:#409eff" @click="openOrderInfo(scope.row)">
                {{ scope.row.order_num }}</el-link>
            </template>
          </el-table-column>
          <el-table-column label="园区" prop="order_park" width="100"></el-table-column>
          <el-table-column label="服务状态" prop="service_status" width="100"></el-table-column>
          <el-table-column label="退款状态" prop="refund_status">
            <template slot-scope="scope">
              <span v-if="scope.row.refund_status == 0">待审核</span>
              <span v-else-if="scope.row.refund_status == 1">已审核</span>
              <span v-else-if="scope.row.refund_status == 2">提交申请</span>
              <span v-else-if="scope.row.refund_status == 3">已完成</span>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" prop="total_amount"></el-table-column>
          <el-table-column label="客户姓名" prop="customer_name"></el-table-column>
          <el-table-column label="订单来源" prop="platform" width="130"></el-table-column>
          <el-table-column label="服务顾问">
            <template slot-scope="scope">
              <span>{{ scope.row.advisor.username }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="150"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-drawer title="订单信息" :visible.sync="orderInfoVisible" direction="rtl" size="50%"
      :before-close="handleOrderInfoClose">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <order-info :orderId="orderInfoId"></order-info>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Vue from "vue";
import { fscDate } from "../../../static/mixins/fastChooseDate";
import UserwithOrder from 'common/UserWithOrder'
import OrderInfo from 'common/OrderInfo'
import PhoneCom from "common/PhoneCom";
import DateFormatter from "common/DateFormatter";

export default {
  name: "UserSource",
  mixins: [fscDate],
  components: {
    UserwithOrder,
    OrderInfo,
    PhoneCom,
    DateFormatter
  },
  data() {
    return {
      activeOpen: '',
      inputSize: "small",
      pageOption: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      searchArr: {
        vip_reg: "",
        order_date: "",
      },
      handlePayerContentDrawer: false,
      loading: true,
      userSource: [],
      userLists: [],
      typeForm: {
        phone: "",
      },
      typeUserDrawer: false,
      type: null,
      titleName: "",
      titleEnum: [
        "",
        "支付宝：云上公司注册",
        "支付宝：企业火公司注册",
        "微信：云上公司注册",
        "微信：企业火",
        "抖音：云上公司注册",
      ],
      userOrderWithData: [],
      showLogs: [],
      orderInfoVisible: false,
      orderInfoId: null
    };
  },
  filters: {
    toFixedTwo(value) {
      const num = parseFloat(value); // 将 value 转换为浮点型数值
      if (isNaN(num)) {
        return "0.00"; // 如果无法转换为数字，则返回 '0.00'
      } else {
        return num === 0 ? "0.00" : num.toFixed(2); // 如果 num 为零，则返回 '0.00'，否则保留两位小数
      }
    },
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }
      return str;
    },
    // typeInPickerOptions: function () {
    //   var _this = this;
    //   return {
    //     shortcuts: [
    //       {
    //         text: "今天",
    //         onClick(picker) {
    //           const todayDate = new Date().toLocaleDateString();
    //           var dateArr = _this.nowDate(todayDate);
    //           const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
    //           const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //       {
    //         text: "昨天",
    //         onClick(picker) {
    //           const dd = new Date();
    //           dd.setDate(dd.getDate() - 1);
    //           var yesterDate = dd.toLocaleDateString();
    //           var dateArr = _this.nowDate(yesterDate);
    //           const start = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 0, 0, 0);
    //           const end = new Date(dateArr[0], dateArr[1] - 1, dateArr[2], 23, 59, 59);
    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //       {
    //         text: "本周",
    //         onClick(picker) {
    //           var now = new Date();
    //           const year = now.getFullYear();
    //           const month = now.getMonth();
    //           const day = now.getDate();
    //           const week = now.getDay();

    //           let start = new Date(year, month, day - week + 1, 0, 0, 0);
    //           let end = new Date(year, month, day - week + 7, 23, 59, 59);

    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //       {
    //         text: "上周",
    //         onClick(picker) {
    //           var dateS = _this.getWeek(-1, 0).split("-");
    //           var dateE = _this.getWeek(-1, 1).split("-");

    //           let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0);
    //           let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59);

    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //       {
    //         text: "本月",
    //         onClick(picker) {
    //           var str = _this.getCurrentDate();

    //           var arr = _this.getfirstDateAndlastDate(str);

    //           var arrS = arr[0].split("-");
    //           var arrE = arr[1].split("-");

    //           var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
    //           var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //       {
    //         text: "上个月",
    //         onClick(picker) {
    //           var str = _this.fromLastMonth();

    //           var arr = _this.getfirstDateAndlastDate(str);

    //           var arrS = arr[0].split("-");
    //           var arrE = arr[1].split("-");

    //           var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0);
    //           var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59);

    //           picker.$emit("pick", [start, end]);
    //         },
    //       },
    //     ],
    //   };
    // },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    handleGetUserSource() {
      this.$axios
        .get("/api/admin/user/get_user_source?type=1" + this.searchStr)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.userSource = data.data.userSource;
          }
        });
    },
    handleGetTypeUser(type) {
      this.type = type;
      this.$axios
        .get(
          "/api/admin/user/get_users_by_type?page=" +
          this.pageOption.currentPage +
          "&pageSize=" +
          this.pageOption.pageSize +
          "&type=" +
          this.type +
          "&phone=" +
          this.typeForm.phone
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.userLists = data.data.userLists.data;
            this.pageOption.total = data.data.userLists.total;
          }
        })
        .finally(() => {
          this.loading = false;
          this.typeUserDrawer = true;
          this.titleName = this.titleEnum[this.type];
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    handleOrderInfoOpen(phoneNumber) {
      this.$axios
        .post('/api/customer/get_customer_order', { phone: phoneNumber })
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.userOrderWithData = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
      this.handlePayerContentDrawer = true
    },
    openOrderInfo(row) {
      this.orderInfoVisible = true
      setTimeout(() => {
        this.orderInfoId = row.id
      }, 0)
    },
    handleTypeSerch() {
      this.pageOption.currentPage = 1;
      this.handleGetTypeUser(this.type);
    },
    handleASearSub() {
      this.activeOpen = '';
      this.handleGetUserSource();
    },
    handleOrderInfoClose(done) {
      this.orderInfoId = null
      done()
    },
    handleASearClear() {
      this.searchArr.vip_reg = "";
      this.searchArr.order_date = "";
      this.activeOpen = '';
      this.handleGetUserSource();
    },
    handleTypeClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.typeForm.phone = ''
          done()
        })
        .catch((_) => { })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.handlePayerContentDrawer = false
          done()
        })
        .catch((_) => { })
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handleGetTypeUser(this.type);
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handleGetTypeUser(this.type);
    },
    renderHeader(h, { column }) {
      // 共用的表头
      return h("span", column.label);
    },
    nowDate(date) {
      return date.split("/");
    },
    getWeek(n, type) {
      // 周
      let now = new Date();
      let day = now.getDay(); // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1);
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7);
        } else {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber);
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber + 1 + 6); // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1;
          now.setDate(now.getDate() - dayNumber - 7 + 6);
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day;
          now.setDate(now.getDate() + dayNumber);
        }
      }
      let date = now.getDate();
      let month = now.getMonth() + 1;

      let s =
        now.getFullYear() +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date);
      return s;
    },
    getfirstDateAndlastDate(dateC) {
      var dateStr = dateC;
      var date = new Date(dateStr);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      if (month > 12) {
        month = 1;
        year++;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var monthLastDay = new Date(year, month, 0).getDate();
      var firstDate = year + "-" + month + "-" + "01";
      var lastDate = year + "-" + month + "-" + monthLastDay;
      return [firstDate, lastDate];
    },
    getCurrentDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    fromLastMonth() {
      var date = new Date();
      var lastMonthDate = "";
      // 获取当前几号，如果小于10则补0
      var day = date.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      var month = date.getMonth();
      var year = date.getFullYear();
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + "-12-" + day;
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = "0" + month;
        }
        lastMonthDate = year + "-" + month + "-" + day;
      }
      return lastMonthDate;
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.handleGetUserSource();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.ellipsis-link {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.number-cell {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.total-class {
  margin: .4rem 0 0 .4rem;
}

.number-cell::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.setBadge >>> .el-badge__content.is-fixed {
  top: 0.22rem;
  right: 0.06rem;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.schedule >>> .el-drawer__header {
  font-size: 0.36rem;
  font-weight: 400;
  color: #4D84FE;
}

.schedule >>> .el-table__header th {
  color: #333333;
}

.schedule >>> .el-timeline-item__node--normal {
  left: 0;
  background-color: #ECF4FF;
}

.el-select, .el-cascader {
  width: 100%;
}

.schedule {
  marginLeft();

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.clearfix:before, .clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.search-row .el-col {
  margin-bottom: 0.2rem;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.tr {
  text-align: right;
}

.mt-50 {
  margin-top: 1rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mb-10 {
  margin-bottom: 0.2rem;
}

.m-tabs-content {
  padding: 0 0.2rem 0 0.4rem;

  .tabs-title {
    color: #5789F4;
  }

  .m-label {
    line-height: 0.64rem;
  }

  .el-row {
    margin-bottom: 0.4rem;
  }

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 100%;
  }
}

.el-date-editor {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/my_customers/UserSource.vue